import { getCenterOfSafeZone } from '../../map/mapHelpers.tsx'
import { LatLng } from '../../map/types.ts'

export const centerMapOnZone = (map: google.maps.Map, zone: any) => {
    const center = getCenterOfSafeZone(zone.zone_coordinates)
    map.panTo(center as LatLng)
}


